function Footer() {


    return (
        <>
    <footer class="site-footer">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <h6>Acerca De</h6>
            <p class="text-justify">Somos una empresa Ambateña con más de 15 años de experiencia, brindando servicios de internet y transmisión de datos de alta capacidad y velocidad, brindando un servicio estable, seguro y rápido con nuestra red de fibra óptica satisfaciendo así los requerimientos de la población.  </p>
          </div>

          <div class="col-xs-6 col-md-3">
            <h6>Categorias</h6>
            <ul class="footer-links">
              <li><a href="./#">Internet Hogar</a></li>
              <li><a href="./corporativo">Internet Corporativo</a></li>
              <li><a href="./streaming">Streaming</a></li>
              <li><a href="./dual">Dual</a></li>
            </ul>
          </div>

          <div class="col-xs-6 col-md-3">
            <h6>Links</h6>
            <ul class="footer-links">
              <li><a href="./#">Inicio</a></li>
              <li><a href="./#">Nosotros</a></li>
              <li><a href="./#">Planes</a></li>
              <li><a href="./#">Links de Interes</a></li>
              <li><a href="./#">Contáctanos</a></li>
            </ul>
          </div>
        </div>
        <hr/>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-sm-6 col-xs-12">
            <p class="copyright-text">Copyright &copy; 2023 All Rights Reserved by
         <a href="#"> Agencia Prez</a>.
            </p>
          </div>
        </div>
      </div>
</footer>
        </>
    );
}

export default Footer;
